import { createSignal } from "solid-js";
import { createStore } from "solid-js/store";

import { GetUserInfoByUserIDRsp } from "@/types/swagger/front";

// 是否可编辑资料
export const [isEdit, setIsEdit] = createSignal<boolean>(true);
// 类型
interface Profile {
  userId: number;
  profileInfo: GetUserInfoByUserIDRsp;
}
// 原数据
const initialStore: Profile = {
  userId: 0,
  profileInfo: {} as GetUserInfoByUserIDRsp,
};
// store
export const [profileStore, setProfileStore] = createStore<Profile>(
  JSON.parse(JSON.stringify(initialStore)),
);
// 个人信息
export const profileInfo = () => {
  return profileStore.profileInfo;
};

// 用户id
export const profileId = () => {
  return profileStore.userId;
};
